module.exports = __webpack_public_path__ + "static/media/aman_patil.972af498.jpg";